module.exports = __webpack_public_path__ + "static/media/advertismenttop2.424582cc.jpg";